<template>
  <div class="side-menu">
    <div class="buynow-btn" @click="orderNow">立即下单</div>
    <div class="buynow-btn" @click="addMoney">去充值</div>
    <div class="buynow-btn" v-if="main" @click="toInvite()">邀请赚佣</div>
    <!-- <div class="buynow-btn" v-if="main && zuanshi" @click="toYuTang()">百万鱼塘</div> -->
    <el-menu :default-active="$route.path" :style="main && zuanshi ? 'top: 225px' : !main && !zuanshi ? 'top: 150px' : 'top: 190px' " class="el-menu-vertical-demo" router @select="handleSelect">
      <el-submenu :index="item.index" v-for="(item, index) in menu" :key="index">
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{item.title}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="(i, k) in item.items" :key="k" :index="i.path">{{i.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { myMemberInfo } from 'network/api'
export default {
  data () {
    return {
      menu: [
        {
          index: '/orderAdmin',
          title: '订单管理',
          icon: 'el-icon-set-up',
          items: [
            {
              name: '礼品采购',
              path: '/orderAdmin/purchase'
            },
            {
              name: '订单列表',
              path: '/orderAdmin/orderList'
            },
            {
              name: '包裹列表',
              path: '/orderAdmin/packList'
            },
            {
              name: '店铺绑定',
              path: '/orderAdmin/storeBind'
            },
            {
              name: '余额管理',
              path: '/account/balance'
            },
            {
              name: '收益明细',
              path: '/account/income'
            },
            {
              name: '异常订单',
              path: '/account/errorOrder'
            }
            // {
            //   name: '发件地址',
            //   path: '/orderAdmin/sendAddress'
            // }
          ]
        },
        {
          index: '/account',
          title: '个人中心',
          icon: 'el-icon-user',
          items: [
            {
              name: '基础信息',
              path: '/account/base'
            },
            // {
            //   name: '余额管理',
            //   path: '/account/balance'
            // },
            {
              name: '邀请奖励',
              path: '/account/inviteRewards'
            },
            {
              name: '邀请好友',
              path: '/account/InviteFriends'
            }
          ]
        },
        // {
        //   index: '/workOrder',
        //   title: '工单中心',
        //   icon: 'el-icon-document',
        //   items: [
        //     {
        //       name: '提交工单',
        //       path: '/workOrder/orderSumbit'
        //     },
        //     {
        //       name: '我的工单',
        //       path: '/workOrder/myOrder'
        //     }
        //   ]
        // },
        {
          index: '/oem',
          title: '网站后台',
          icon: 'el-icon-monitor',
          items: [
            {
              name: '网站管理',
              path: '/oem/manage'
            }
          ]
        }
      ],
      main: false,
      zuanshi: false
    }
  },
  mounted () {
    this.main = this.$configList[window.location.host] === '1459435534555418624'
    this.getMemberinfo()
    if (this.isMain) {
      this.menu[0].items.push({
        name: '推广收益',
        path: '/account/tgIncome'
      })
    }
  },
  methods: {
    // 立即下单
    orderNow () {
      this.$router.push('/orderAdmin/purchase')
    },
    addMoney () {
      this.$router.push('/account/balance')
    },
    toInvite () {
      this.$router.push('/account/InviteFriends')
    },
    toYuTang () {
      this.$router.push('/saleOrder')
    },
    // 菜单激活回调
    handleSelect (indexPath) {
      this.$emit('getIndexPath', indexPath)
    },
    getMemberinfo () {
      myMemberInfo().then((res) => {
        if (res.data.total_recharge_money >= 50 || res.data.top_up_amount >= 50) {
          this.zuanshi = true
        }
      })
    }
  }
}

</script>

<style scoped src="styles/components/sideMenu.css">
</style>

<style>
  .side-menu .el-menu-vertical-demo.el-menu {
    position: fixed;
    top: 170px;
    bottom: 0;
    left: 0;
    width: 200px;
    overflow-y: auto;
  }

  .side-menu .el-menu-vertical-demo.el-menu::-webkit-scrollbar {
    display: none;
  }

  .side-menu .el-menu {
    border-right: 0px;
  }

  .side-menu .el-menu .el-menu-item {
    font-weight: 600;
    color: rgba(0,0,0,.65);
  }

  .side-menu .el-submenu__title i:last-child {
    font-weight: 600;
  }

  .side-menu .el-submenu__title, .side-menu .el-submenu__title i {
    color: #000000A6;
  }

  .side-menu .el-submenu.is-opened .el-submenu__title, .side-menu .el-submenu.is-opened .el-submenu__title i {
    color: #1890ff;
  }

  .side-menu .el-menu .el-menu-item.is-active {
    color: #1890ff;
    border-right: 3px #1890ff solid;
  }
</style>
